export default {
  '首页': 'Homepage',
  '更多': 'More',
  '更多信息，请联系学院咨询。': 'For more information, please contact the college for consultation.',

  '教学项目': 'Programs and Admission',
  '金融博士课程': 'PhD in Finance',
  '数字金融科技硕士课程': 'MSc in DFT',
  '全球文创金融领袖课程': 'Global Cultural & Creative Finance Leader',
  '全球战略领袖学者计划': 'Global strategic Leaders Fellowship (GSLF)',
  '金融专业硕士课程': 'Master of Finance',
  '金融MBA课程': 'MBA in Finance',
  '金融EMBA课程': 'EMBA in Finance',
  '高管教育课程': 'Executive Education Programs',
  '在线教育课程': 'Online and Distance Courses',
  '线上报名': 'APPLY',
  '我要报名': 'APPLY',
  '下载': 'Download',
  '报考我们': 'Apply for us',

  '师资力量': 'Faculty',
  '全职师资': 'Full-time Professors',
  '院聘研究员': 'Research Fellow-in-Residence',
  '特聘教授': 'Distinguished Professors',
  '访问学者': 'Visiting Scholars',
  '业界导师': 'Professors of Management Practice',
  '教师招聘': 'Recruitment',
  '师者故事': 'Stories',
  '教研系列': 'Faculty Recruitment',
  '研究系列': 'Staff Recruitment',
  '博士后': 'Postdoctoral Recruitment',
  '师资': 'Faculty',
  '招聘': 'Recruitment',
  '正在更新中...': 'Updating in progress...',

  '科学研究': 'Research',
  '研究成果': 'Insights and Publications',
  '科研机构': 'HKSF Research Center',
  '《香港金融评论》编辑部': 'HKFR Media Center',
  '亚洲金融论坛AFF研究中心': 'AFF Research Center',

  '学生发展': 'Study with HKSF',
  '学生生活': 'Student Life',
  '研团协会': 'Student Affairs Management Committee',
  '社团协会': 'Student Clubs',
  '思政教育': 'Ideological Political Education',
  '职业发展': 'Career Development',

  '国际交流': 'Global Programs',
  '合作项目': 'Joint Programmes',
  '硕士项目': 'Master of Finance with Dual Degrees',
  '双学位金融MBA': 'Global MBA',
  'EMBA项目': 'Global EMBA',
  '金融学博士项目': 'PhD in Finance',
  '交换项目': 'Student Exchange',
  '暑期项目': 'Summer Schools',
  '金博全球模块': 'Finance PhD Global Module',
  '最新动态': 'Latest News',
  '学生感言': 'Student Spotlights',
  '动态': 'Updates',
  '交流': 'communication',

  '校友': 'Alumni',
  '校友服务': 'Alumni Services',
  '校友职业发展': 'Career Development',
  '正文': 'Main text',

  '合作发展': 'Support',
  '捐赠项目': 'Donation Programs',
  '在线捐赠': 'Online Donation',
  '座椅捐赠': 'Seat Donation',
  '限量': 'Limited to',
  '把，每把座椅认捐金额': 'seats, with each seat requiring a donation',
  '为': 'of',
  '22000元': '22,000 RMB',
  '(冠名期限': '(the naming rights for a single donation are valid for',
  '10年': '10 years',
  '),最多可冠名': 'and naming rights can be renewed for a maximum of ',
  '两期': 'two consecutive terms.',
  '冠名捐赠千人报告厅座椅': 'Donate to name seats in the 1,000-seat lecture hall',
  '支持香港政治金融学院金融发展与人才培养基地建设': 'Support the development, construction and talent cultivation of HKSF',
  '请扫描二维码支持香港政治金融学院建设': 'Please scan the QR code to support the construction of HKSF',
  '我们将与您联系后续流程': 'We will contact you regarding the follow-up procedures',
  '香港政治金融学院座椅捐赠': 'Seat Donation for HKSF',
  '我要捐赠': 'I want to donate',

  '关于我们': 'About us',
  '学院简介': 'About HKSF',
  '学院寄语': 'School Welcome',
  '学院文化': 'Culture and Prospect',
  '联系我们': 'Contact us',
  '我们': 'WE',
  '愿 景': 'Vision',
  '成为世界领先的政治金融学院——全球政商界精英的培养摇篮': 'To become a world-leading institute of political science and finance — a cradle for cultivating global elites in politics and business',
  '使命': 'Mission',
  '塑造未来金融领袖、搭建国际合作平台——推动金融创新实践、促进全球行业发展': 'Shaping future financial leaders, building an international cooperation platform — promoting financial innovation practices and advancing global industry development',
  '香港政治金融学院': 'Hong Kong School of Finance and Political Science',

  '新闻动态': 'HKSF News',
  '政金观点': 'HKSF Insights',
  '焦点专题': 'Featured Topics',
  '通知公告': 'Information for Students',
  '查看项目': 'View Programs',
  '论坛活动': 'Academic Events/Seminars',
  '发展': 'Development',
  '时间': 'time',

  '香港政治金融学院 版权所有': 'HKSF All Rights Reserved',
  '粤ICP备2026102046号-2': 'Guangdong ICP Filing No. 2026102046-2',
  '联系电话': 'Contact Phone Number',
  '香港': 'Hong Kong',
  '深圳': 'Shenzhen',
  '传真号码': 'Fax Number',
  '官方邮箱地址': 'Official Email Address',
  '官方网站': 'Official Website',
  '深圳地址': 'Shenzhen Address',
  '深圳市福田区香蜜湖街道侨香公馆5B401': '5B401, Qiaoxiang Mansion, Xiangmihu Subdistrict, Futian District, Shenzhen',

  '香港政治金融学院（HKSF）': 'Hong Kong School of Financial and Political Science (HKSF) ',
  '融汇东西方智慧，共塑全球金融未来': 'Integrating Eastern and Western Wisdom to Shape the Future of Global Finance',
  '变革与机遇并存的时代，政治与金融深度交织，重塑世界未来格局。香港政治金融学院(Hongkong School of Financial and Political Science,以下简称HKSF)背靠香江，面向全球，以独特的': 'In an era defined by transformation and opportunity, where politics and finance are profoundly intertwined, the global landscape is being reshaped. The Hong Kong School of Financial and Political Science (HKSF), strategically positioned in Hong Kong with a global outlook, cultivates the next generation of visionary leaders and scholars through its distinctive',
  '“政金融合”教育体系，': ' "Convergence of Politics and Finance" educational paradigm. ',
  '培养兼具': 'Graduates emerge with',
  '战略远见、国际视野与实践智慧': ' strategic foresight, international perspective, and practical acumen.',
  '的新一代领袖学者。': '',
  '在这里，您将融入由': 'At HKSF, you will engage within an elite ecosystem comprising ',
  '政策制定者、金融精英、跨国企业领袖、专家教授': 'policymakers, financial leaders, multinational executives, and distinguished academics. ',
  '组成的顶级生态，通过': 'Our pedagogy integrates theory with practice, combining ',
  '理论梳理、案例实战、热点研讨、前沿科技应用、企业走访': 'rigorous academic frameworks, case-based simulations, topical seminars, cutting-edge technology applications, and corporate field studies. ',
  '等学习方式，融贯中西，掌握驾驭复杂格局的核心能力。无论是金融创新、政策分析，还是地缘经济战略、科技创新应用，HKSF提供的不只是教育，更是塑造未来的影响力网络。': 'This immersive approach fosters mastery in navigating complex global dynamics—whether in financial innovation, policy analysis, geoeconomic strategy, or technological transformation. HKSF delivers not merely education, but a powerful network shaping the future.',
  '办学特色': 'Distinctive Advantages',
  '地缘枢纽': 'Geopolitical Nexus',
  '作为国际金融中心，香港凭借制度优势、高度开放的资本市场及普通法体系，成为连接中国内地与全球金融市场的核心节点。HKSF深度依托这一独特地缘格局，构建贯通东西方的政经学术枢纽。': 'Leveraging Hong Kong’s status as an international financial hub—with its institutional strengths, open capital markets, and common law framework—HKSF serves as a pivotal academic bridge linking Asia and global financial systems.',
  '政金融合': 'Interdisciplinary Convergence',
  '国际政治与经济金融深度交叉的课程体系，全面捕捉前沿课题，以“学术-实践”双轨设计为核心，丰富新颖的案例教学、情景模拟、策略沙盘推演，培养具备全球格局视野的跨界领袖。': "Our curriculum synthesizes international political economy with advanced finance. Centered on a dual-track 'Theory-to-Practice' design, it employs dynamic case studies, scenario modeling, and strategic simulations to develop globally minded, cross-sector leaders.",
  '学习生态': 'Dynamic Learning Ecosystem',
  '金融硕士、数字金融科技硕士、国际金融MBA、EMBA、DBA、短期专题研讨等多元项目/课程，提供动态适配的学习方案。课程主题丰富，学习模式灵活。聚合跨国企业高管、政策制定者、金融翘楚、科学家，在紧密协作中淬炼战略决策力与全球领导力。': 'A diverse portfolio—including Master of Finance, MSc in Digital Finance and Technology, International Finance MBA, EMBA, DBA, and specialized executive programs—offers tailored learning pathways. Flexible formats and rich content facilitate collaboration among multinational executives, policymakers, financial innovators, and scientists, honing strategic decision-making and global leadership.',
  '前沿创新': 'Frontier Innovation',
  '突破传统商科边界，联动顶尖学术机构与国际组织、高科技企业，深度开展人工智能、区块链技术、材料化工、数据工程、生命科学、深空探测、法律与政策监管、可持续发展等前沿领域研究，驱动金融科技与政策创新实践。': 'Transcending traditional business education, HKSF partners with leading academic institutions, international organizations, and technology firms to pioneer research in AI, blockchain, materials science, data engineering, life sciences, deep-space exploration, regulatory frameworks, and sustainable development—driving fintech and policy innovation.',
  '价值网络': 'Global Value Network',
  '构建覆盖全球国家政商精英的校友体系，依托香港战略区位及全球金融智库网络，持续赋能学生校友的发展跃迁与跨界资源整合。': 'A powerful alumni network spans global policy and business elites. Supported by Hong Kong’s strategic location and our worldwide financial think-tank partnerships, we empower continuous professional advancement and cross-border resource integration.',
  '使命愿景': 'Mission & Vision',
  '以 “科学思辨、趋势前瞻、知行合一、敢当无我”为理念，打造政金交叉学科全球高地：': "Guided by 'Intellectual Rigor, Future Foresight, Actionable Insight, and Commitment Beyond Self-Interest,' HKSF aspires to be the global leader in political-financial interdisciplinary education:",
  '锻造': 'To forge ',
  '通晓国际法律法规，深谙亚太区域实践的金融领军企业家': 'financial leaders adept in international regulation and Asia-Pacific dynamics.',
  '搭建': 'To facilitate ',
  '政策制定与金融创新的跨国对话平台': 'transnational dialogue between policymakers and financial innovators.',
  '驱动': 'To drive ',
  '亚洲金融枢纽建设与全球行业变革': 'Hon Kong’s evolution as a financial nexus and catalyze global industry transformation.',
  '关键优势': 'Core Strengths',
  '学术纵深：': 'Academic Excellence:',
  '诺奖得主、银行政策顾问、全球顶尖科学家、多学科专家学者': 'Nobel Laureates, central bank advisors, leading scientists, and multidisciplinary scholars.',
  '实战锚点：': 'Industry Anchors: ',
  '与高盛、金管局、亚投行、前沿数字科技企业等共建战略合作实验室': 'Strategic labs co-developed with Goldman Sachs, HKMA, AIIB, and frontier tech firms.',
  '跨界网络：': 'Elite Network: ',
  '学生平均从业年限15年+，覆盖主权基金、跨国企业及政策机构': 'Cohort average 15+ years of experience across sovereign funds, MNCs, and policy institutions.',
  '区位赋能：': 'Strategic Location: ',
  '坐拥香港核心金融生态圈，直连粤港澳大湾区创新链': 'Embedded within Hong Kong’s core financial ecosystem and the Greater Bay Area innovation corridor.',
  '加入 HKSF，加入重塑全球金融秩序的先锋阵营': 'Join HKSF—Join the Vanguard of Global Finance Transformation',
  '我们致力于为商界领袖、政策制定者及金融创新者': 'We empower business leaders, policymakers, and financial innovators',
  '提供超越传统商学院的战略赋能，在百年变局中共同缔造可持续的全球繁荣。': 'with strategic capabilities beyond conventional business education. Together, we build sustainable global prosperity in a century of change.',

  '作为亚洲国际都会，香港独特的地理位置和历史背景，为我们提供了无与伦比的机会去探寻政治与金融的发展前景。香港政治金融学院正是基于这样的优势，致力于培养具有全球视野、深谙中国国情、精通国际金融的未来领袖。': "As an international metropolis in Asia, Hong Kong, with its unique geographical location and historical background, provides us with unparalleled opportunities to explore the development prospects of politics and finance. Based on such advantages, the HKSF is committed to cultivating future leaders with a global perspective, a deep understanding of China's national conditions, and proficiency in international finance",
  '学院植根香港，背靠祖国，面向世界。在这个充满挑战与机遇的时代，学院肩负着推动社会进步的重要使命。作为院长，我深感责任重大，同时也充满信心和期待。': 'The College is rooted in Hong Kong, backed by the motherland, and oriented towards the world. In this era full of challenges and opportunities, the College shoulders the important mission of promoting social progress. As the president, I deeply feel the great responsibility, and at the same time, I am full of confidence and expectations',
  '学院致力于提供卓越的教育，培养具有全球视野、创新精神和责任感的金融人才。在这里，你们将接受世界一流、独具特色的学术课程，掌握前沿的金融知识和政治经济分析能力。我们将提供丰富的实践平台，与国际著名的金融企业或者组织保持密切合作，将学术研究与实际应用紧密结合，使你们能够适应复杂的全球政治经济环境，成为全球金融和政治经济领域的中坚力量。': 'The College is dedicated to providing excellent education and cultivating financial talents with a global vision, innovative spirit and sense of responsibility. Here, you will receive world-class and unique academic courses, and master cutting-edge financial knowledge as well as political and economic analysis capabilities. We will provide a wealth of practical platforms and maintain close cooperation with internationally renowned financial enterprises or organizations, closely integrating academic research with practical applications, enabling you to adapt to the complex global political and economic environment and become the backbone in the fields of global finance, politics and economy',
  '作为政治金融学院的一员，我期待看到你们在未来的职业生涯中，运用所学知识和技能，应对全球挑战，推动社会进步。让我们携手努力，共同创造一个更加公平、可持续和繁荣的世界。': 'As a member of the HKSF, I look forward to seeing you in your future careers, using the knowledge and skills you have learned to meet global challenges and promote social progress. Let us work together to create a more fair, sustainable and prosperous world',
  '欢迎加入香港政治金融学院，让我们一起践行“塑造未来金融领袖，搭建国际合作平台，推动金融创新实践，促进全球行业发展”的学院使命，协力打造国际领先的政治金融高等教育平台，成为全球金融未来的摇篮。': "Welcome to join the HKSF. Let us jointly fulfill the College's mission of 'Shaping future financial leaders, building an international cooperation platform, promoting financial innovation practices, and facilitating global industry development', work together to build an internationally leading higher education platform for political science and finance, and become the cradle of the global financial future",

  '取消': 'Cancel',
  '提交': 'Submit',
  '提交中...': 'Submitting...',
  '香港政治金融学院教育基金会   创建': 'Established by HKSF Education Foundation',
  '报名费收款账户信息': 'Registration fee receiving account information',
  '收款方:': 'Payee:',
  '收款银行:': 'Receiving bank:',
  '银行编号:': 'Bank code:',
  '香港政治金融学院有限公司': 'HKSF Limited',
  '中国工商银行(亚洲)': 'Industrial and Commercial Bank of China (Asia)',
  '返回': 'Return',

  '点击上传': 'Click to upload',
  '上传中': 'Uploading',
  '上传中...': 'Uploading',
  '单个扫描件小于2M，最多可上传两个文件。': 'Each scanned file must be less than 2MB. A maximum of two files can be uploaded.',

  '申请流程': 'Application Process',
  '香港政治金融学院综合考察申请人的基本素质、教育背景、工作经历及企业规模，择优录取。': "Hong Kong School of Finance and Political Science conducts a comprehensive review of applicants' core competencies, educational background, work experience, and company scale for admission.",
  '高管研修项目申请流程如下：': 'Executive Education Programme Application Process:',
  '一、网上报名：': '1. Online Application: ',
  '在线填写并提交正式申请表。': 'Complete and submit the official application form online.',
  '二、资料审核：': '2. Document Review: ',
  '提交完整资料后，项目老师将尽快联系您，告知审核结果及后续安排。': 'After submitting all required documents, the programme coordinator will contact you shortly to inform you of the review outcome and next steps.',
  '三、面谈：': '3. Interview:',
  '通过初审的申请人将参加线上或现场面谈。': 'Shortlisted applicants will be invited for an online or in-person interview.',
  '四、综合评估：': '4. Comprehensive Evaluation:',
  '结合申请资料与面谈表现进行综合评估。': 'A final assessment will be made based on your application materials and interview performance.',
  '五、录取及入学：': '5. Admission and Enrollment: ',
  '如被录取，学校将发送正式录取通知书。请按要求缴纳学费并办理入学手续，班主任将通知详细入学安排。': 'Successful candidates will receive a formal admission notice. Please complete the tuition payment and enrollment procedures as instructed. The programme administrator will then notify you of the detailed orientation schedule.',
  '确认并在线填写申请表': 'Confirm and fill in the application form online',

  '请填写报名表': 'Please fill in the application form',
  '请备好相关材料并一次完成填写，以免影响资料保存。': 'Please have all required documents ready and complete the application in one session to ensure successful submission.',
  // 证件类型
  '大陆居民身份证': 'Mainland Resident ID Card',
  '外籍护照': 'Foreign Passport',
  '港澳台回乡证': 'Hong Kong, Macao and Taiwan Home Return Permit',
  '华侨身份证': 'Overseas Chinese ID Card',

  // 国籍/地区
  '中国': 'China',
  '朝鲜': 'North Korea',
  '美国': 'United States',
  '韩国': 'South Korea',
  '加拿大': 'Canada',
  '印度': 'India',
  '新西兰': 'New Zealand',
  '泰国': 'Thailand',
  '俄罗斯': 'Russia',
  '马来西亚': 'Malaysia',
  '哈萨克斯坦': 'Kazakhstan',
  '日本': 'Japan',
  '印度尼西亚': 'Indonesia',
  '其他地区': 'Other Regions',
  '罗马尼亚': 'Romania',
  '新加坡': 'Singapore',
  '匈牙利': 'Hungary',
  '法国': 'France',
  '德国': 'Germany',
  '澳大利亚': 'Australia',
  '荷兰': 'Netherlands',
  '意大利': 'Italy',
  '英国': 'United Kingdom',
  '阿尔巴尼亚': 'Albania',
  '阿尔及利亚': 'Algeria',
  '阿富汗': 'Afghanistan',
  '阿根廷': 'Argentina',
  '阿拉伯联合酋长国': 'United Arab Emirates',
  '阿曼': 'Oman',
  '阿塞拜疆': 'Azerbaijan',
  '埃及': 'Egypt',
  '埃塞俄比亚': 'Ethiopia',
  '爱尔兰': 'Ireland',
  '爱沙尼亚': 'Estonia',
  '安道尔': 'Andorra',
  '安哥拉': 'Angola',
  '安提瓜和巴布达': 'Antigua and Barbuda',
  '奥地利': 'Austria',
  '巴巴多斯': 'Barbados',
  '巴布亚新几内亚': 'Papua New Guinea',
  '巴哈马': 'Bahamas',
  '巴基斯坦': 'Pakistan',
  '巴拉圭': 'Paraguay',
  '巴勒斯坦': 'Palestine',
  '巴林': 'Bahrain',
  '巴拿马': 'Panama',
  '巴西': 'Brazil',
  '白俄罗斯': 'Belarus',
  '保加利亚': 'Bulgaria',
  '贝宁': 'Benin',
  '比利时': 'Belgium',
  '冰岛': 'Iceland',
  '波兰': 'Poland',
  '波斯尼亚和黑塞哥维那': 'Bosnia and Herzegovina',
  '玻利维亚': 'Bolivia',
  '伯利兹': 'Belize',
  '博茨瓦纳': 'Botswana',
  '不丹': 'Bhutan',
  '布基纳法索': 'Burkina Faso',
  '布隆迪': 'Burundi',
  '赤道几内亚': 'Equatorial Guinea',
  '丹麦': 'Denmark',
  '东帝汶': 'Timor-Leste',
  '多哥': 'Togo',
  '多米尼加共和国': 'Dominican Republic',
  '多米尼克': 'Dominica',
  '厄瓜多尔': 'Ecuador',
  '厄立特里亚': 'Eritrea',
  '梵蒂冈': 'Vatican City',
  '菲律宾': 'Philippines',
  '斐济': 'Fiji',
  '芬兰': 'Finland',
  '佛得角': 'Cape Verde',
  '冈比亚': 'Gambia',
  '刚果共和国': 'Republic of the Congo',
  '刚果民主共和国': 'Democratic Republic of the Congo',
  '哥伦比亚': 'Colombia',
  '哥斯达黎加': 'Costa Rica',
  '格林纳达': 'Grenada',
  '格鲁吉亚': 'Georgia',
  '古巴': 'Cuba',
  '圭亚那': 'Guyana',
  '海地': 'Haiti',
  '黑山共和国': 'Montenegro',
  '洪都拉斯': 'Honduras',
  '基里巴斯': 'Kiribati',
  '吉布提': 'Djibouti',
  '吉尔吉斯斯坦': 'Kyrgyzstan',
  '几内亚': 'Guinea',
  '几内亚比绍': 'Guinea-Bissau',
  '加纳': 'Ghana',
  '加蓬': 'Gabon',
  '柬埔寨': 'Cambodia',
  '捷克共和国': 'Czech Republic',
  '津巴布韦': 'Zimbabwe',
  '喀麦隆': 'Cameroon',
  '卡塔尔': 'Qatar',
  '科摩罗': 'Comoros',
  '科特迪瓦': 'Côte d\'Ivoire',
  '科威特': 'Kuwait',
  '克罗地亚': 'Croatia',
  '肯尼亚': 'Kenya',
  '拉脱维亚': 'Latvia',
  '莱索托': 'Lesotho',
  '老挝': 'Laos',
  '黎巴嫩': 'Lebanon',
  '立陶宛': 'Lithuania',
  '利比里亚': 'Liberia',
  '利比亚': 'Libya',
  '列支敦士登': 'Liechtenstein',
  '卢森堡': 'Luxembourg',
  '卢旺达': 'Rwanda',
  '马达加斯加': 'Madagascar',
  '马尔代夫': 'Maldives',
  '马耳他': 'Malta',
  '马拉维': 'Malawi',
  '马里': 'Mali',
  '马其顿共和国': 'Republic of North Macedonia',
  '马绍尔群岛': 'Marshall Islands',
  '毛里求斯': 'Mauritius',
  '毛里塔尼亚': 'Mauritania',
  '蒙古': 'Mongolia',
  '孟加拉国': 'Bangladesh',
  '秘鲁': 'Peru',
  '密克罗尼西亚': 'Micronesia',
  '缅甸': 'Myanmar',
  '摩尔多瓦': 'Moldova',
  '摩洛哥': 'Morocco',
  '摩纳哥': 'Monaco',
  '莫桑比克': 'Mozambique',
  '墨西哥': 'Mexico',
  '纳米比亚': 'Namibia',
  '南非共和国': 'South Africa',
  '南苏丹': 'South Sudan',
  '瑙鲁': 'Nauru',
  '尼泊尔': 'Nepal',
  '尼加拉瓜': 'Nicaragua',
  '尼日尔': 'Niger',
  '尼日利亚': 'Nigeria',
  '挪威': 'Norway',
  '帕劳': 'Palau',
  '葡萄牙': 'Portugal',
  '瑞典': 'Sweden',
  '瑞士': 'Switzerland',
  '萨尔瓦多': 'El Salvador',
  '萨摩亚': 'Samoa',
  '塞尔维亚': 'Serbia',
  '塞拉利昂': 'Sierra Leone',
  '塞内加尔': 'Senegal',
  '塞浦路斯': 'Cyprus',
  '塞舌尔': 'Seychelles',
  '沙特阿拉伯': 'Saudi Arabia',
  '圣多美和普林西比': 'São Tomé and Príncipe',
  '圣基茨和尼维斯': 'St. Kitts and Nevis',
  '圣卢西亚': 'St. Lucia',
  '圣马力诺': 'San Marino',
  '圣文森特和格林纳丁斯': 'St. Vincent and the Grenadines',
  '斯里兰卡': 'Sri Lanka',
  '斯洛伐克': 'Slovakia',
  '斯洛文尼亚': 'Slovenia',
  '斯威士兰': 'Eswatini',
  '苏丹': 'Sudan',
  '苏里南': 'Suriname',
  '所罗门群岛': 'Solomon Islands',
  '索马里': 'Somalia',
  '塔吉克斯坦': 'Tajikistan',
  '坦桑尼亚': 'Tanzania',
  '汤加': 'Tonga',
  '特立尼达和多巴哥': 'Trinidad and Tobago',
  '突尼斯': 'Tunisia',
  '图瓦卢': 'Tuvalu',
  '土耳其': 'Turkey',
  '土库曼斯坦': 'Turkmenistan',
  '瓦努阿图': 'Vanuatu',
  '危地马拉': 'Guatemala',
  '委内瑞拉': 'Venezuela',
  '文莱': 'Brunei',
  '乌干达': 'Uganda',
  '乌克兰': 'Ukraine',
  '乌拉圭': 'Uruguay',
  '乌兹别克斯坦': 'Uzbekistan',
  '西班牙': 'Spain',
  '西撒哈拉': 'Western Sahara',
  '希腊': 'Greece',
  '叙利亚': 'Syria',
  '牙买加': 'Jamaica',
  '亚美尼亚': 'Armenia',
  '也门': 'Yemen',
  '伊拉克': 'Iraq',
  '伊朗': 'Iran',
  '以色列': 'Israel',
  '约旦': 'Jordan',
  '越南': 'Vietnam',
  '赞比亚': 'Zambia',
  '乍得': 'Chad',
  '智利': 'Chile',
  '中非共和国': 'Central African Republic',

  // 民族
  '无': 'None',
  '汉族': 'Han',
  '蒙古族': 'Mongolian',
  '回族': 'Hui',
  '藏族': 'Tibetan',
  '维吾尔族': 'Uyghur',
  '苗族': 'Miao',
  '彝族': 'Yi',
  '壮族': 'Zhuang',
  '布依族': 'Buyi',
  '朝鲜族': 'Korean',
  '满族': 'Manchu',
  '侗族': 'Dong',
  '瑶族': 'Yao',
  '白族': 'Bai',
  '土家族': 'Tujia',
  '哈尼族': 'Hani',
  '哈萨克族': 'Kazak',
  '傣族': 'Dai',
  '黎族': 'Li',
  '傈僳族': 'Lisu',
  '佤族': 'Va',
  '畲族': 'She',
  '高山族': 'Gaoshan',
  '拉祜族': 'Lahu',
  '水族': 'Shui',
  '东乡族': 'Dongxiang',
  '纳西族': 'Naxi',
  '景颇族': 'Jingpo',
  '柯尔克孜族': 'Kyrgyz',
  '土族': 'Tu',
  '达斡尔族': 'Daur',
  '仫佬族': 'Mulao',
  '羌族': 'Qiang',
  '布朗族': 'Blang',
  '撒拉族': 'Salar',
  '毛难族': 'Maonan',
  '仡佬族': 'Gelao',
  '锡伯族': 'Xibe',
  '阿昌族': 'Achang',
  '普米族': 'Pumi',
  '塔吉克族': 'Tajik',
  '怒族': 'Nu',
  '乌孜别克族': 'Uzbek',
  '俄罗斯族': 'Russian',
  '鄂温克族': 'Ewenki',
  '崩龙族': 'Deang',
  '保安族': 'Bonan',
  '裕固族': 'Yugur',
  '京族': 'Gin',
  '塔塔尔族': 'Tatar',
  '独龙族': 'Derung',
  '鄂伦春族': 'Oroqen',
  '赫哲族': 'Hezhen',
  '门巴族': 'Monba',
  '珞巴族': 'Lhoba',
  '基诺族': 'Jino',

  // 政治面貌
  '中国共产党党员': 'Member of the Communist Party of China',
  '中国共产党预备党员': 'Probationary Member of the Communist Party of China',
  '中国共产主义青年团团员': 'Member of the Communist Youth League of China',
  '中国国民党革命委员会会员': 'Member of the Revolutionary Committee of the Chinese Kuomintang',
  '中国民主同盟盟员': 'Member of the China Democratic League',
  '中国民主建国会会员': 'Member of the China National Democratic Construction Association',
  '中国民主促进会会员': 'Member of the China Association for Promoting Democracy',
  '中国农工民主党党员': 'Member of the Chinese Peasants and Workers Democratic Party',
  '中国致公党党员': 'Member of the China Zhi Gong Party',
  '九三学社社员': 'Member of the Jiusan Society',
  '台湾民主自治同盟盟员': 'Member of the Taiwan Democratic Self-Government League',
  '无党派人士': 'Non-Party Personage',
  '群众': 'The Public',

  // 职务级别
  '高层管理(董事会主席、董事、总裁、副总裁、总经理、副总经理等)': 'Senior Management (Chairman, Board Director, President, Vice President, General Manager, Deputy General Manager, etc.)',
  '中高层管理(区域总经理、分公司总经理、业务总经理)': 'Upper-Middle Management (Regional General Manager, Branch General Manager, Business Unit Head)',
  '中层管理(区域经理、部门经理、顾问)': 'Middle Management (Regional Manager, Department Manager, Consultant)',

  // 单位性质
  '国有/国有控股': 'State-Owned/State-Controlled',
  '政府/事业单位': 'Government/Public Institution',
  '股份制企业': 'Joint-Stock Enterprise',
  '外资': 'Foreign-Invested',
  '民营/私营': 'Private',

  // 培训原因
  '公司指派学习': 'Company-Assigned Study',
  '业务发展需要': 'Business Development Needs',
  '个人发展需要': 'Personal Development Needs',
  '知识补充积累': 'Knowledge Supplement and Accumulation',

  // 渠道
  '我是校友': 'I am an alumni',
  '校友推荐': 'Referred by alumni',
  '学院网站': 'School website',
  '朋友口碑': 'Word-of-mouth from friends',
  '活动': 'Event',
  '直邮(纸质直邮、电子直邮)': 'Direct mail (print/email)',
  '广告(今日头条、百度搜索、微信推送、其他)': 'Advertising (Toutiao, Baidu Search, WeChat push, etc.)',
  '其他': 'Other',

  // 表单标签
  '申请项目': 'Applying for Program',
  '请选择申请项目': 'Please select your desired program',
  '手机号': 'Phone Number',
  '请填写手机号': 'Please enter your phone number',
  '姓名': 'Full Name',
  '请填写真实姓名': 'Please enter your name',
  '性别': 'Gender',
  '男': 'Male',
  '女': 'Female',
  '身份证件': 'ID Document',
  '请选择证件类型': 'Please select ID type',
  '请填写证件号码': 'Please enter ID number',
  '邮件': 'Email',
  '请填写邮件': 'Please enter your email',
  '出生日期': 'Date of Birth',
  '请选择出生日期': 'Please select your date of birth',
  '国籍': 'Nationality',
  '请选择国籍': 'Please select your nationality',
  '民族': 'Ethnicity',
  '请选择民族': 'Please select your ethnicity',
  '政治面貌': 'Political Status',
  '请选择政治面貌': 'Please select your political status',
  '通讯地址': 'Mailing Address',
  '请选择通讯地址': 'Please select your mailing address',
  '请输入您的长居国家': 'Please enter your country of permanent residence.',
  '请填写详细地址': 'Please enter detailed address',
  '常住地': 'Country/Region of Residence',
  '教育背景': 'Education Background',
  '最高学历': 'Highest Degree Obtained',
  '博士': 'Doctoral Degree',
  '硕士': 'Master’s Degree',
  '本科': 'Bachelor’s Degree',
  '专科及以下': 'Associate Degree/ College Diploma or Below',
  '毕业日期': 'Graduation Date',
  '请选择毕业日期': 'Please select your graduation date',
  '学校': 'School',
  '请填写学校': 'Please enter your school',
  '培训经历': 'Training Experience',
  '添加培训经历': 'Add Training Experience',
  '工作经历': 'Work Experience',
  '公司名称': 'Company Name',
  '请填写公司名称': 'Please enter your company name',
  '所属部门': 'Department',
  '请填写所属部门': 'Please enter your department',
  '现任职务': 'Current Job Title',
  '请填写现任职务': 'Please enter your current position',
  '担任该职务时长': 'Tenure in Current Position',
  '请选择担任该职务时长': 'Please select duration in current position',
  '职务级别': 'Job Level',
  '请选择职务级别': 'Please select your job level',
  '主管人数': 'Number of Direct Reports',
  '请填写主管人数': 'Please enter the number of subordinates',
  '公司所属行业': 'Industry',
  '请选择公司所属行业': 'Please select your company’s industry',
  '单位性质': 'Nature of Organization',
  '请选择单位性质': 'Please select the nature of your organization',
  '公司人数': 'Company Size',
  '请填写公司人数': 'Please enter your company size',
  '公司网址': 'Company Website',
  '请填写公司网址': 'Please enter your company website',
  '年营业额': 'Annual Revenue',
  '请填写年营业额': 'Please enter annual revenue',
  '公司总资产': 'Total Assets',
  '请填写公司总资产': 'Please enter total assets',
  '公司是否上市': 'Is the Company Listed?',
  '未上市': 'Not Listed',
  '已上市': 'Listed',
  '股票代码': 'Stock Code',
  '请填写股票代码': 'Please enter the stock code',
  '是否需要添加联系人（助理）': 'Add contact person (assistant)?',
  '需要': 'Yes',
  '不需要': 'No',
  '是否为党政机关、国有企业、事业单位领导干部': 'Are you a leading official of Party/government organ, SOE, or public institution?',
  '根据相关规定，党政机关、国有企业、事业单位领导干部参加培训项目需提供相关材料，具体情况请咨询招生老师。': 'According to regulations, leading officials from Party and government organs, state-owned enterprises, and public institutions are required to submit supporting documents. Please contact the admissions office for details.',
  '联系人姓名': 'Contact Name',
  '请填写联系人姓名': 'Please enter the contact name',
  '联系人手机': 'Contact Phone',
  '请填写联系人手机': 'Please enter the contact phone number',
  '联系人邮箱': 'Contact Email',
  '请填写联系人邮箱': 'Please enter the contact email',
  '联系人职位': 'Contact Position',
  '请填写联系人职位': 'Please enter the contact position',
  '其他问题': 'Additional Questions',
  '费用承担方': 'Who will bear the training cost?',
  '个人': 'Individual',
  '公司': 'Company',
  '参加本次培训的原因': 'Reason for attending this training program',
  '请选择参加本次培训的原因': 'Please select your reason for attending this training program',
  '通过何种渠道获得本次课程培训信息的': 'How did you learn about this program?',
  '请选择通过何种渠道获得本次课程培训信息的': 'Please select how you learned about this training program',
  '参加本次培训的期望': 'Expectations for this program',
  '请填写参加本次培训的期望': 'Please enter your expectations for this program',
  '商学院/培训公司': 'Business School/Training Company',
  '请填写商学院/培训公司': 'Please enter the business School/Training Company',
  '课程名称': 'Course Name',
  '请填写课程名称': 'Please enter the course name',
  '开始日期': 'Start Date',
  '请选择开始日期': 'Please select the start date',
  '结束日期': 'End Date',
  '请选择结束日期': 'Please select the end date',
  '操作': 'Actions',
  '编辑': 'Edit',
  '删除': 'Delete',
  '确定': 'Confirm',
  '是': 'Yes',
  '否': 'No',
  '请选择通信地址': 'Please enter your accurate address for receiving official notices and study materials.',
  '请选择常住地': 'Please select Country/Region of Residence',
  '万元': 'million HKD',
  '教育阶段': 'Education Level',
  '请选择教育阶段': 'Please select education Level',
  '专业': 'Major',
  '请填写专业': 'Please enter your major',
  '入学日期': 'Enrollment Date',
  '学位证件': 'Degree Certificate',
  '请选择入学日期': 'Please select enrollment date.',
  '请上传您的学历及学位证件': 'Please upload your academic degree certificates',
  '添加教育经历': 'Add Education Experience',
  '毕业日期不能早于入学日期': 'Graduation date cannot be earlier than enrollment date',
  '是否为香港永久居民': 'Hong Kong Permanent Citizen',
  '教育经历': 'Education Experience',
  '上传证件照': 'Upload ID Photo',
  '上传学位证': 'Upload Degree Certificate',
  '请输入您的长居城市': 'Please enter city name',

  '高管培训项目报名': 'Executive Education Program Application',
  '基本信息': 'Basic Information',
  '照片上传': 'Photo Upload',
  '二寸彩色白底免冠照': '2-inch Color White Background Passport Photo',
  '证件扫描件': 'Scanned Copy of ID Document',
  '上传证件扫描件': 'Upload Scanned Copy of ID Document',
  '公司/单位名称': 'Company/Organization Name',
  '请填写公司/单位名称': 'Please enter company/organization name',
  '公司/单位网址': 'Company/Organization Website',
  '请填写公司/单位网址': 'Please enter company/organization website',
  '公司/单位简介': 'Company/Organization Profile',
  '请填写公司/单位简介': 'Please enter company/organization profile',
  '公司/单位所属行业': 'Company/Organization Industry',
  '请选择公司/单位所属行业': 'Please select company/organization industry',
  '公司/单位性质': 'Company/Organization Type',
  '请选择公司/单位性质': 'Please select company/organization type',
  '公司/单位员工人数(全球)': 'Number of Emplyees(Global)',
  '请填写公司/单位员工人数(全球)': 'Please enter number of Emplyees(Global)',
  '公司/单位上财年年度总资产': 'Total Assets of Previous Fiscal Year（HKD）',
  '请填写公司/单位上财年年度总资产': 'Please enter total assets of previous fiscal year',
  '公司/单位上财年年度总营收额': 'Total Revenue of Previous Fiscal Year（HKD）',
  '请填写公司/单位上财年年度总营收额': 'Please enter total revenue of previous fiscal year',
  '公司/单位上财年年度净利润': 'Net Profit of Previous Fiscal Year（HKD）',
  '请填写公司/单位上财年年度净利润': 'Please enter net profit of previous fiscal year',
  '您的直接下属员工人数': 'Number of Direct Reports',
  '请选择您的直接下属员工人数': 'Please select number of direct reports',
  '请选择图片文件': 'Please select an image file.',
  '最多只能上传2个文件': 'You can upload a maximum of 2 files.',
  '文件大小不能超过2M': 'Maximum file size allowed is 2M.',
  '删除成功': 'Deleted successfully.',
  '添加成功': 'Added successfully',
  '修改成功': 'Updated successfully',
  '裁剪失败，请重试': 'Cropping failed, please try again',
  '图片裁剪并上传成功': 'Image cropped and uploaded successfully',
  '图片上传失败': 'Image upload failed',
  '确定要删除这条培训经历吗？': 'Are you sure you want to delete this training experience?',
  '提示': 'Tip',
  '确定要删除这条教育经历吗？': 'Are you sure you want to delete this education experience?',
  '图片裁剪': 'Image Crop',
  '确定裁剪并上传': 'Confirm Crop and Upload',
  '上市地点': 'Listing Location',
  '请填写上市地点': 'Please fill in the listing location',
  '股票交易代码': 'Stock Ticker Symbol',
  '请填写股票交易代码': 'Please fill in the stock ticker symbol',
  '请填写您的直接下属员工人数': 'Please fill in the number of your direct subordinates',
  '请检查是否有必填项未填写。': 'Please check if any required fields are left blank.',
  '请添加教育经历': 'Please add education experience.',

  '认识HKSF': 'Discover HKSF',
  '香港政治金融学院主题影片': 'Official HKSF Film ',
  '了解HKSF': 'Explore HKSF',
  '一所面向世界的社会科学研究型学院': 'A Globally Oriented School of Social Sciences',
  '从香港出发，连接不同学术传统与思想资源，以社会科学理解真实世界，回应时代的重要问题。': 'Based in Hong Kong and connected to the world, HKSF brings together diverse intellectual traditions and academic perspectives to advance the understanding of society through rigorous social science research and to respond to the most significant challenges of our time.'
}



// WEBPACK FOOTER //
// ./src/lang/en.js